import { createAction, props } from '@ngrx/store';

import { BAC_ACTION_PREFIX } from '../constants';

export const setPromoCodeId = createAction(
  `${BAC_ACTION_PREFIX} Set affiliate promo code id`,
  props<{ promoCodeId: string | null }>()
);
